import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import FlaggedConnectionsDashboardForm from "./flagged-connections-dashboard-form";
import FlaggedConnectionsDashboardData from "./flagged-connections-dashboard-data";

const FlaggedConnectionsDashboard = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_FLAGGED_CONNECTIONS",
      "DEVELOPER_FLAGGED_CONNECTIONS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("FLAGGED_CONNECTIONS")}
        subTitle={i18n.get("FLAGGED_CONNECTIONS_DASHBOARD")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <FlaggedConnectionsDashboardForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <FlaggedConnectionsDashboardData />
    </ET3PageDiv>
  );
});

export default FlaggedConnectionsDashboard;
